import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => {
  const storedProfile = sessionStorage.getItem("userProfile");
  return {
    error: "",
    success: "",
    user: storedProfile ? JSON.parse(storedProfile) : {},
  };
};

export const initialState = getInitialState();

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    profileSuccess(state, action) {
      state.success = action.payload.status;
      state.user = action.payload.data;
      sessionStorage.setItem(
        "userProfile",
        JSON.stringify(action.payload.data)
      );
    },
    profileError(state, action) {
      state.error = action.payload;
    },
    editProfileChange(state) {
      state = { ...state };
    },
    resetProfileFlagChange(state: any) {
      state.success = null;
    },
    updateProfileImage(state, action) {
      state.user.profile_image = action.payload;
      const updatedUser = { ...state.user, profile_image: action.payload };
      sessionStorage.setItem("userProfile", JSON.stringify(updatedUser));
      state.user = updatedUser;
    },
  },
});

export const {
  profileSuccess,
  profileError,
  editProfileChange,
  resetProfileFlagChange,
  updateProfileImage,
} = ProfileSlice.actions;

export default ProfileSlice.reducer;
